import React, { useEffect, useState } from 'react';
import { ArrowRight, Check, ExternalLink } from 'lucide-react';

const SERVICES_LIST = ['Paint protection film', 'Ceramic coating', 'Window tint', 'Vinyl wrap', 'Paint correction', 'New vehicle package', 'Not sure yet'];

const Field = ({ label, children }) => (
  <label className="block">
    <span className="meta block mb-3">{label}</span>
    {children}
  </label>
);

const URABLE = 'https://app.urable.com/virtual-shop/0q8IKq00bWUdZX8RUFZj';

export default function BookingForm({ prefill = '', compact = false, preferredDate = '', vehicleName = '' }) {
  const [form, setForm] = useState({ name: '', contact: '', vehicle: '', service: SERVICES_LIST[0], message: '' });
  const [done, setDone] = useState(null);

  useEffect(() => {
    if (prefill || vehicleName) setForm((f) => ({ ...f, vehicle: vehicleName || f.vehicle, message: prefill || f.message, service: 'New vehicle package' }));
  }, [prefill, vehicleName]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const ref = 'SX-' + Math.random().toString(36).slice(2, 6).toUpperCase();
    setDone(ref);
  };

  if (done) {
    return (
      <div data-testid="booking-success" className="border border-[#e6e2dc] bg-warm p-8 md:p-10">
        <div className="w-11 h-11 rounded-full bg-red flex items-center justify-center text-white"><Check size={18} /></div>
        <p className="font-display h-sub mt-8">Demo request prepared.</p>
        <p className="mt-4 body max-w-md">
          Reference <span className="font-mono text-red font-medium">{done}</span>. No booking was made and this prototype did not send or save your details.
        </p>
        <p className="meta mt-8">{form.vehicle || 'Vehicle'} · {form.service}{preferredDate ? ` · ${preferredDate}` : ''}</p>
        <a href={URABLE} target="_blank" rel="noreferrer" className="btn btn-red mt-8">Continue to official booking <ExternalLink size={14} /></a>
      </div>
    );
  }

  return (
    <form data-testid="booking-form" onSubmit={submit} className={`grid grid-cols-1 ${compact ? '' : 'md:grid-cols-2'} gap-8`}>
      <Field label="Name">
        <input data-testid="booking-name" required value={form.name} onChange={set('name')} className="field" placeholder="Your name" />
      </Field>
      <Field label="Phone or email">
        <input data-testid="booking-contact" required value={form.contact} onChange={set('contact')} className="field" placeholder="613 000 0000" />
      </Field>
      <Field label="Vehicle">
        <input data-testid="booking-vehicle" required value={form.vehicle} onChange={set('vehicle')} className="field" placeholder="2025 BMW M3, Frozen White" />
      </Field>
      <Field label="Service">
        <select data-testid="booking-service" value={form.service} onChange={set('service')} className="field">
          {SERVICES_LIST.map((s) => <option key={s}>{s}</option>)}
        </select>
      </Field>
      <div className={compact ? '' : 'md:col-span-2'}>
        <Field label="Details">
          <textarea data-testid="booking-message" rows={4} value={form.message} onChange={set('message')} className="field resize-none" placeholder="Coverage you have in mind, timeline, or anything we should know." />
        </Field>
      </div>
      <div className={`${compact ? '' : 'md:col-span-2'} flex flex-col md:flex-row md:items-center justify-between gap-6`}>
        <p className="meta">Demo only · Details are not sent, saved or reserved</p>
        <button data-testid="booking-submit" type="submit" className="btn btn-red w-fit">Prepare demo request <ArrowRight size={14} /></button>
      </div>
    </form>
  );
}
